import {
  FieldError as FieldErrorType,
  FieldErrors,
  FieldPath,
  FieldValues,
  UseFormReturn,
} from "react-hook-form";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { FieldError } from "../../components/Form/BaseField";

interface FieldListErrorProps<TFieldValues extends FieldValues> {
  form: UseFormReturn<TFieldValues>;
  name: FieldPath<TFieldValues>;
  itemName: FieldPath<TFieldValues>;
  index: number;
}

export const FieldListErrorStyle = styled.div`
  margin-bottom: 25px;
`;

export function FieldListError<TFieldValues extends FieldValues>({
  name,
  form,
  index,
  itemName,
}: FieldListErrorProps<TFieldValues>) {
  const errors = form.formState.errors as FieldErrors<TFieldValues>;

  const fieldArrayErrors = errors[name] as
    | FieldErrors<TFieldValues>[]
    | undefined;
  const fieldError = fieldArrayErrors?.[index]?.[itemName] as
    | FieldErrorType
    | undefined;

  return fieldError?.message ? (
    <FieldListErrorStyle>
      <FieldError>
        <FontAwesomeIcon icon={faExclamationCircle} size="1x" />
        <span>{fieldError.message || "This field is required"}</span>
      </FieldError>
    </FieldListErrorStyle>
  ) : null;
}
